import { render } from "./UserAccessGroups.vue?vue&type=template&id=551e0256"
import script from "./UserAccessGroups.vue?vue&type=script&lang=js"
export * from "./UserAccessGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__